import { FooterData, Location } from "../../../sanity/lib/queries/getFooterData";
import { UnstyledLink } from "../link/unstyledLink";
import { ImageElement } from "../Image";
import { FooterSvg } from "./footerSvg";

export const Footer = ({ data }: { data: FooterData }) => {
    return (
        <div>
            <footer className="container footer">
                <div className="mx-2.5 md:mx-5 mb-[2.125rem] mt-5">
                    <div className="grid grid-cols-2 gap-5 py-5">
                        {data.locations?.map((location: Location) => (
                            <div
                                key={location.title}
                                className="col-span-2 md:col-span-1 grid md:flex md:justify-between grid-cols-2 flex-row-reverse md:flex-col gap-2.5 md:gap-8"
                            >
                                <div className="flex flex-col justify-between order-2 col-span-1 md:col-span-2 md:order-1">
                                    <h3 className="mb-2 m-headline-1 md:d-headline-3">
                                        {location.title}
                                    </h3>
                                    <p className="flex flex-col gap-1 m-body-m md:d-body-m whitespace-break-spaces">
                                        {location.address}
                                    </p>
                                </div>
                                <div className="relative order-1 col-span-1 md:col-span-2 md:order-2 location-image">
                                    {location.image?.image && (
                                        <ImageElement
                                            loading="lazy"
                                            src={location.image?.image}
                                            width={1100}
                                            alt={location.title}
                                            className="md:w-full object-cover aspect-[173/97] md:aspect-[689/432] relative"
                                        />
                                    )}
                                    {location.hoverImage?.image && (
                                        <ImageElement
                                            loading="lazy"
                                            src={location.hoverImage?.image}
                                            width={1100}
                                            alt={location.title}
                                            className="footer-hover-image md:w-full object-cover aspect-[173/97] md:aspect-[689/432] absolute top-0 left-0 opacity-0"
                                        />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mx-2.5 md:mx-5 grid grid-cols-4 gap-2.5 md:gap-5">
                    <FooterSvg />
                    <div className="flex flex-col col-span-2 gap-3 md:col-span-1">
                        {data.footerNavigation?.map((link, idx) => (
                            <div key={idx}>
                                <UnstyledLink link={link} />
                            </div>
                        ))}
                    </div>
                    <div className="flex flex-col col-span-2 gap-3 md:col-span-1">
                        <div className="flex flex-col gap-3">
                            {data.socialMediaLinks?.map((link, idx) => (
                                <div key={idx}>
                                    <UnstyledLink link={link} />
                                </div>
                            ))}
                        </div>

                        <div className="flex flex-col gap-3">
                            <div>
                                <UnstyledLink link={data.impressumLink} />
                            </div>
                            <div>
                                <UnstyledLink link={data.agbLink} />
                            </div>
                            <div>
                                <UnstyledLink link={data.privacyLink} />
                            </div>
                            <div>
                                <button
                                    onClick={() => (window as any).klaro?.show()}
                                    className="text-left m-link-l md:d-link-l hover:no-underline"
                                >
                                    {data.cookiePreferences}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col col-span-4 gap-3 pt-8 md:col-span-1 md:pt-0">
                        {data.email && (
                            <div>
                                <UnstyledLink
                                    link={{
                                        _type: "link",
                                        label: data.email.label,
                                        type: "external",
                                        external: "mailto:" + data.email.emailAddress,
                                    }}
                                />
                            </div>
                        )}
                        {data.phone && (
                            <div>
                                <UnstyledLink
                                    link={{
                                        _type: "link",
                                        label: data.phone.label,
                                        type: "external",
                                        external: `tel:${data.phone.phoneNumber}`,
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>

                <div className="mx-2.5 md:mx-5 flex justify-start md:justify-end mb-24 md:mb-[1.375rem] d-body-m pt-24 md:pt-[2.125rem]">
                    <p>
                        ©{data.copyright || "dotsandlines"} {new Date().getFullYear()}
                    </p>
                </div>
            </footer>
        </div>
    );
};
